import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
/**
 * Takes a Redux action and returns a correctly memoized function that will dispatch it.
 *
 * The function returned by this hook expects all the same parameters as the action creator.
 */ export function useAction(actionCreator) {
    const dispatch = useDispatch();
    return useCallback((...args)=>{
        dispatch(actionCreator(...args));
    }, [
        dispatch,
        actionCreator
    ]);
}

//# sourceMappingURL=useAction.js.map